@if (!isDetailViewActive) {
  <h4 class="d-flex align-items-center justify-content-between">
    <span class="text-muted">Calls</span>
    <span>
      <generic-date-range-filter [label]="filter.dateRange?.displayText" [icon]="'fa-solid fa-filter'" [popoverLocation]="'bottom'"
        [dateRange]="filter.dateRange" [clearVisible]="false" (filtersChanged)="onRangesFilterChanged($event)">
      </generic-date-range-filter>
    </span>
  </h4>
  <div class="w-100" style="height: 40px;">
    <p-iconfield class="w-100 h-100">
      <input pInputText #searchInput type="text" class="form-control h-100" style="min-height: 2.5rem;" (input)="search(searchInput.value)"
        [disabled]="isLoading" placeholder="Search keyword" />
        <p-inputicon styleClass="pi pi-search" />
      </p-iconfield>
    </div>
    @if (!isLoading) {
      <div class="w-100 mt-2 p-2 call-dates-list d-flex flex-column flex-grow-1" id="call-dates-list">
        @for (date of callDates; track date) {
          <label class="control-label my-1">{{ date }}</label>
          <div class="w-100 summary-container">
            @for (callHistory of timeGroupedCallHistory?.get(date); track callHistory.voiceHistoryId || $index) {
              <div class="row summary-row" [class.me-1]="hasListScroll"
                (click)="goToDetail(callHistory)">
                <div class="col-2">
                  <div class="w-100 h-100 d-flex align-items-center justify-content-center" title="Go To Detail">
                    <div class="border rounded-circle p-2"
                      [ngClass]="{'outgoing-call': callHistory.direction == 'Outbound', 'incoming-call': callHistory.direction == 'Inbound'}">
                        <!-- outgoing-call.svg -->
                        @if (callHistory.direction == 'Outbound') {
                            <img
                              src="assets/icons/phone-outgoing.svg"
                              alt="Outgoing call"
                              class="call-icon"
                            />
                        }
                        <!-- incoming-call.svg -->
                        @if (callHistory.direction == 'Inbound') {
                          <img
                            src="assets/icons/phone-incoming.svg"
                            class="call-icon"
                            alt="Incoming call"
                          />
                        }
                        </div>
                      </div>
                    </div>
                    <div class="col-6" title="Go To Detail">
                      <h5 class="mb-0" style="margin-top: 12px;">
                        <a class="nav-link d-inline p-0" title="Call Details" (click)="$event.stopPropagation(); goToDetail(callHistory)">
                          {{ (callHistory.fromWithoutCountryCode | mask: '(000) 000-0000') || '--' }}
                        </a>
                      </h5>
                      <div>{{ callHistory.durationText }}</div>
                    </div>
                    <div class="col-4" title="Go To Detail">
                      <div class="d-flex align-items-center justify-content-end" style="margin-top: 18px;">
                        @if (callHistory.callRecorded) {
                          <a (click)="$event.stopPropagation(); loadRecordingDetails(callHistory.voiceHistoryId)"
                            title="Play Recording" class="btn btn-xs btn-soft-primary me-1" href="javascript: void(0);">
                            <i class="fa-solid fa-play-circle" aria-hidden="true"></i>
                          </a>
                          <a (click)="$event.stopPropagation(); downloadRecordingDetails(callHistory.voiceHistoryId, null)"
                            title="Download Recording" class="btn btn-xs btn-soft-primary me-1" href="javascript: void(0);">
                            <i class="fa-solid fa-download" aria-hidden="true"></i>
                          </a>
                        }
                        <a (click)="$event.stopPropagation(); openCallPanel(callHistory)"
                          title="Dial Number" class="btn btn-xs btn-soft-primary" href="javascript: void(0);">
                          <i class="fa-solid fa-phone-flip" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                    @if (!!listeningRecordingHistory && listeningVoiceHistoryId === callHistory.voiceHistoryId) {
                      <div class="mt-1" (click)="$event.stopPropagation()">
                        <app-audio-player-widget [duration]="listeningRecordingHistory.durationInSeconds" [audioSrc]="listeningRecordingHistory.mp3RecordingUri"></app-audio-player-widget>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (isLoading) {
          <div class="h-100 px-2">
            <loading-indicator [customClass]="'no-shadow'" loadingMessage="Loading..."></loading-indicator>
          </div>
        }
      }
      @if (isDetailViewActive) {
        <h4 class="d-flex align-items-center mb-4">
          <span class="flex-grow-1 text-start text-muted">Details</span>
          <span class="text-primary cursor" (click)="goToList()" title="Go To List"><i class="fas fa-arrow-left me-2"></i>
        Calls</span>
      </h4>
      <div class="call-details flex-grow-1">
        <h4 class="d-flex align-items-center justify-content-between mb-2">
          <span class="text-muted">Summary</span>
          <span> </span>
        </h4>
        <div class="card me-1" style="height: 300px; overflow: auto;">
          <div class="card-body">
            <h2>Transcript</h2>
            <div>Coming soon...</div>
          </div>
        </div>
        <h4 class="d-flex align-items-center justify-content-between my-2">
          <span class="text-muted">Information</span>
          <span></span>
        </h4>
        <div class="summary-detail-container mb-1">
          <div class="row summary-detail-row">
            <div class="col-6"><span class="text-muted">Direction</span></div>
            <div class="col-6 text-end">{{ selectedCallHistory.direction || '--' }}</div>
          </div>
          <div class="row summary-detail-row">
            <div class="col-6 "><span class="text-muted">From</span></div>
            <div class="col-6 text-end">{{ (selectedCallHistory.fromWithoutCountryCode | mask: '(000) 000-0000' ) || '--'
              }}
            </div>
          </div>
          <div class="row summary-detail-row">
            <div class="col-6 "><span class="text-muted">To</span></div>
            <div class="col-6 text-end">{{ (selectedCallHistory.toWithoutCountryCode | mask: '(000) 000-0000' ) || '--'
              }}
            </div>
          </div>
          <div class="row summary-detail-row">
            <div class="col-6 "><span class="text-muted">Start Date</span></div>
            <div class="col-6 text-end">{{ selectedCallHistory.startDate | date: 'longDate' }}</div>
          </div>
          <div class="row summary-detail-row">
            <div class="col-6 "><span class="text-muted">End Date</span></div>
            <div class="col-6 text-end">{{ selectedCallHistory.endDate | date: 'longDate' }}</div>
          </div>
          <div class="row summary-detail-row">
            <div class="col-6 "><span class="text-muted">Duration</span></div>
            <div class="col-6 text-end">
              <span class="text-success badge badge-soft-success"> {{ selectedCallHistory.durationText || '--' }} </span>
            </div>
          </div>
          <div class="row summary-detail-row">
            <div class="col-6 "><span class="text-muted">Disposition</span></div>
            <div class="col-6 text-end">{{ selectedCallHistory.disposition || '--' }}</div>
          </div>
          <div class="row summary-detail-row">
            <div class="col-6 "><span class="text-muted">Actions</span></div>
            <div class="col-6 text-end">
              @if (selectedCallHistory.callRecorded) {
                <div>
                  <a (click)="loadRecordingDetails(selectedCallHistory.voiceHistoryId)" title="Play Recording"
                    class="btn btn-xs btn-soft-primary me-2" href="javascript: void(0);">
                    <i class="fa-solid fa-play-circle" aria-hidden="true"></i>
                  </a>
                  <a (click)="downloadRecordingDetails(selectedCallHistory.voiceHistoryId, null)" title="Download Recording"
                    class="btn btn-xs btn-soft-primary" href="javascript: void(0);">
                    <i class="fa-solid fa-download" aria-hidden="true"></i>
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
